export default "__VITE_ASSET__a508b6dd__"